import React, { Component } from 'react';
import { appService } from '../../_services';
import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

export class StaticContent extends Component {
    displayName = StaticContent.name
    constructor(props){
        super(props);
        this.state ={content:''};
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        var self = this;
        appService.getByName('appdata/GetAppData?fieldName='+params.page)
        .then(function (data) {
            self.setState({ content: data });
        });
        
    }

    componentWillReceiveProps(nextProps) {
        var self = this;
        appService.getByName('appdata/GetAppData?fieldName='+nextProps.location.state.page)
        .then(function (data) {
            self.setState({ content: data });
        });
    }

    render() {

        const meta = {
            title: "Kluwer Law Online - " + this.state.content.name
        }

        //alert(this.state.props.page);
        var content = this.state.content.value;
        return (
            <DocumentMeta {...meta}>
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="TitlePadding Title">{this.state.content.name}</p>
                            <div className="TitlePadding" dangerouslySetInnerHTML={{__html: content}} />
                        </div>
                    </div>
                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </div>
            </DocumentMeta>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer Section/StaticContent.jsx